import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "devextreme/dist/css/dx.light.css";
import App from "./App";
import { ThemeProvider } from "./context/themeProvider";
import { ConfigProvider } from "antd";
import { getCustomAntdTheme } from "./theme/customAntdTheme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

document.addEventListener("DOMContentLoaded", () => {
  const customTheme = getCustomAntdTheme();

  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <div className="font-poppins text-text">
          <ConfigProvider theme={customTheme}>
            <App />
          </ConfigProvider>
        </div>
      </ThemeProvider>
    </React.StrictMode>
  );
});
